import { render } from "./DesktopMenuItemLink.vue?vue&type=template&id=510b4a86"
import script from "./DesktopMenuItemLink.vue?vue&type=script&lang=js"
export * from "./DesktopMenuItemLink.vue?vue&type=script&lang=js"

import "./DesktopMenuItemLink.vue?vue&type=style&index=0&id=510b4a86&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__